import React from 'react';

// material-ui
import { Link, LinkProps } from '@mui/material';

// third-party
import { Link as RouterLink } from 'react-router-dom';

// ==============================|| CRM ENTITY NAME LINK ||============================== //

/**
 * The single place the CRM "open a business/contact in a new tab" behaviour and
 * its `rel` value live (POGO-13781). It is a thin pass-through over the
 * Tasks-list `Link component={RouterLink}` pattern plus the existing
 * `target="_blank"` / `rel="noopener noreferrer"` convention — composed once so
 * every name cell renders a real `<a href target="_blank">` (native
 * middle-click / Ctrl-Cmd-click / "open in new tab" / copy-link all work) with a
 * consistent `rel`.
 *
 * Styling is left to each consumer: `variant`, `underline`, `sx`, etc. forward
 * straight through so the component never fights a view's existing look.
 */
type EntityNameLinkProps = Omit<LinkProps, 'component' | 'href'> & { to: string };

const EntityNameLink = ({ to, children, ...rest }: EntityNameLinkProps) => (
    <Link component={RouterLink} to={to} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
    </Link>
);

export default EntityNameLink;
